export function getTransactions(state) {
  return state.transactions;
}

export function getPagination(state) {
  return state.pagination;
}